import store from "../store/store";
import firebase from "firebase/app";
import "firebase/auth";
import "firebaseui/dist/firebaseui.css";
import "firebase/analytics";
import "firebase/storage";
import "firebase/firestore";
import router from "../router/router";
import i18n from "../i18n";
import axios from "axios";
import "@firebase/messaging";
import "@firebase/app";

var firebaseConfig = {
  apiKey: process.env.VUE_APP_apiKey,
  authDomain: process.env.VUE_APP_authDomain,
  databaseURL: process.env.VUE_APP_databaseURL,
  projectId: process.env.VUE_APP_projectId,
  storageBucket: process.env.VUE_APP_storageBucket,
  messagingSenderId: process.env.VUE_APP_messagingSenderId,
  appId: process.env.VUE_APP_appId,
  measurementId: process.env.VUE_APP_measurementId,
};
// import firebaseui_ru from "./libs/npm__ru.js";
// import firebaseui_es from "./libs/npm__es_419.js";
// import firebaseui_pt from "./libs/npm__pt_br.js";
// import firebaseui_hi from "./libs/npm__hi.js";

firebase.initializeApp(firebaseConfig);
// console.log(
//   "firebase.messaging.isSupported() firebase",
//   firebase.messaging.isSupported()
// );
let messaging;
if (firebase.messaging.isSupported()) {
  messaging = firebase.messaging();
}

const analyticsMock = {
  logEvent: () => {},
  setCurrentScreen: () => {},
  setUserId: () => {},
};

export const analytics = firebase.analytics.isSupported()
  ? firebase.analytics()
  : analyticsMock;

// api's
// https://ipinfo.io/json
// https://ipapi.co/json

export const getJWTToken = () => {
  return store.state.JWTToken;
};
const Token = async (id) => {
  var User_id = id;
  messaging
    .requestPermission()
    .then(() => firebase.messaging().getToken())
    .then((token) => {
      userChecking(User_id, token).then(function() {});
    })
    .catch(function(err) {
      userChecking(User_id);
      console.log("Unable to get permission to notify.", err);
    });

  // var token=await firebase.messaging().firebaseDependencies.installations.getToken();
  // return token
};

export const logoutDataUpload = async (id, last_logout, count) => {
  var content = {
    merchantId: id,
    last_logout: last_logout,
    logout_count: count,
  };
  var config = {
    method: "post",
    url: `${process.env.VUE_APP_API_ENDPOINT}fsdata/v1/userLogout`,
    data: content,
    headers: {
      "Content-Type": "application/json",
      authorization: store.state.JWTToken,
    },
  };
  await axios(config)
    .then(function(response) {
      console.log(response);
      this.$store.dispatch("logout");
    })
    .catch(function(error) {
      console.log(error);
      this.$store.dispatch("logout");
    });
};

export const fetchingLogoutData = async (id) => {
  var config = {
    method: "get",
    url: `${process.env.VUE_APP_API_ENDPOINT}fsdata/v1/userLogout/${id}`,
    headers: {
      "Content-Type": "application/json",
      authorization: store.state.JWTToken,
    },
  };
  await axios(config)
    .then(function(response) {
      if (response) {
        if (response.data) {
          if (response.data.data) {
            store.dispatch("setLastLogout", response.data.data.last_logout);
            store.dispatch("setLogOutCount", response.data.data.logout_count);
          }
        }
      }
    })
    .catch(function(error) {
      console.log(error);
    });
};

export const downloadUrl = async (fileName) => {
  if (
    store.state.currentForm.id === "default_form" ||
    store.state.currentForm.id === "" ||
    store.state.currentForm.id === "undefined"
  ) {
    const currentUrl = window.location.href;
    var stuff = currentUrl.split("/");
    await generateJWTToken(stuff[4]);
  } else {
    await generateJWTToken(store.state.currentForm.id);
  }
  return fetch(
    `${process.env.VUE_APP_API_ENDPOINT}fsdata/v1/get-download-url`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: getJWTToken() || "",
      },
      body: JSON.stringify({ name: fileName }),
    }
  );
};

export const updateFile = (fileName, content) => {
  return fetch(`${process.env.VUE_APP_API_ENDPOINT}fsdata/v1/update-file`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: getJWTToken() || "",
    },
    body: JSON.stringify({ name: fileName, data: content }),
  });
};

export const save = async (state, country, phone, otp) => {
  var Order_response = {};
  var Order_details = {};
  var Items = [];
  Order_details["merchant_id"] = state.id;
  Order_details["order_form"] = state.shopname;
  Order_details["order_status"] = "Pending";
  Order_details["total_amount"] = parseFloat(state.amount).toFixed(2);
  Order_details["currency"] = state.currency;
  Order_details["symbol"] = state.symbol;
  Order_details["created"] = Date.now();
  state.catalogue.map((item) => {
    if (item.type == "item") {
      if (parseInt(item.qtty) >= 1) {
        var temp = {};
        var price = item.price ? item.price : 0;
        price = +price;
        temp["category"] = item.category ? item.category : "Unorganized";
        temp["name"] = item.name;
        temp["description"] = item.desc;
        temp["price"] = price;
        temp["qty"] = item.qtty;
        var sub_total = parseInt(item.qtty) * price;
        temp["sub_total"] = parseFloat(sub_total).toFixed(2);
        Items.push(temp);
      }
    }
  });
  Order_details["Items"] = Items;
  var config = {
    method: "post",
    url: `${process.env.VUE_APP_API_ENDPOINT}fsdata/v1/createOrder/${country}/Phone/${phone}/OTP/${otp}`,
    data: Order_details,
  };
  await axios(config)
    .then(function(response) {
      Order_response = response.data;
    })
    .catch(function(error) {
      Order_response = error.response.data;
    });
  return Order_response;
};

export const urlShorter = (link) => {
  var result = "";
  var data = JSON.stringify({
    longDynamicLink: `${process.env.VUE_APP_SHORT_LINK_DOMAIN}/?link=${link}`,
    suffix: {
      option: "SHORT",
    },
  });

  var config = {
    method: "post",
    url: `${process.env.VUE_APP_SHORT_URL}?key=${process.env.VUE_APP_apiKey}`,
    headers: {
      "Content-Type": "application/json",
    },
    data: data,
  };

  return axios(config)
    .then(function(response) {
      result = response.data.shortLink;
      return result;
    })
    .catch(function(error) {
      console.log(error);
      return error;
    });
};

export const sendOtpMessage = async (phone, international) => {
  var data = JSON.stringify({
    phone: phone,
    international: international,
  });
  var msg = "";
  var config = {
    method: "post",
    url: `${process.env.VUE_APP_API_ENDPOINT}otp/v1/send-otp`,
    headers: {
      "Content-Type": "application/json",
    },
    data: data,
  };

  await axios(config)
    .then(function() {})
    .catch(function(error) {
      console.log(error);
      msg = error.response.data.message;
    });
  return msg;
};

export const verifyOTP = async (phone, OTP) => {
  var message = "";
  var data = JSON.stringify({
    phone: phone,
    otp: OTP,
  });

  var config = {
    method: "post",
    url: `${process.env.VUE_APP_API_ENDPOINT}otp/v1/verify-otp`,
    headers: {
      "Content-Type": "application/json",
    },
    data: data,
  };

  await axios(config)
    .then(function(response) {
      message = response.data.message;
    })
    .catch(function(error) {
      console.log(error);
    });
  return message;
};

export const getCountryCode = async () => {
  await fetch("https://ipapi.co/json")
    .then((response) => response.json())
    .then((data) => {
      store.dispatch("setCountryCode", data.country_code);
    });
};

export const initApp = async () => {
  firebase.auth().onAuthStateChanged(
    function(user) {
      store.dispatch("setDialog", false);
      if (user) {
        store.dispatch("fetchUser", user);
        var displayName = user.displayName;
        var email = user.email;
        var emailVerified = user.emailVerified;
        var photoURL = user.photoURL;
        var uid = user.uid;
        var phoneNumber = user.phoneNumber;
        var providerData = user.providerData;
        user.getIdToken().then(function(accessToken) {
          var loginuser = {
            displayName: displayName,
            email: email,
            emailVerified: emailVerified,
            phoneNumber: phoneNumber,
            photoURL: photoURL,
            uid: uid,
            accessToken: accessToken,
            providerData: providerData,
          };

          store.dispatch("setOverlay", true);
          var routename = router.currentRoute.name;
          if (routename != "viewform") {
            if (user) {
              login(loginuser);
              store.dispatch("setOverlay", false);
            } else {
              store.dispatch("setOverlay", false);
            }
          }
        });
      } else {
        //controller.navigateInitial(null);
        store.dispatch("setOverlay", true);
        var routename = router.currentRoute.name;
        if (routename != "viewform") {
          if (user) {
            login(user);
            loadMaster(user.uid, function() {
              store.dispatch("setOverlay", false);
            });
          } else {
            store.dispatch("setOverlay", false);
          }
        }
        return null;
      }
    },
    function() {
      //console.log(error);
    }
  );
};

export const login = (user) => {
  user.drawer = false;
  user.loggedin = true;
  store.dispatch("setUserData", user);
};

export const loadNumber = (id, callback) => {
  store.dispatch("setOverlay", true);
  downloadUrl("number.json")
    .then((response) => {
      return response.json();
    })
    .then((data) => {
      fetch(data.message, {
        method: "GET",
        redirect: "follow",
      })
        .then((response) => response.text())
        .then((result) => {
          var phone = JSON.parse(result);
          store.dispatch("setWhatsAppData", phone);
          store.dispatch("setOverlay", false);
          callback(null);
        })
        .catch((error) => {
          store.dispatch("setWhatsAppData", "");
          store.dispatch("setOverlay", false);
          callback(error);
        });
    })
    .catch((error) => {
      store.dispatch("setWhatsAppData", "");
      store.dispatch("setOverlay", false);
      callback(error);
    });
};
export const loadMaster = (id, callback) => {
  store.dispatch("setOverlay", true);
  downloadUrl("master.json")
    .then((response) => {
      return response.json();
    })
    .then((data) => {
      fetch(data.message, {
        method: "GET",
        redirect: "follow",
      })
        .then((response) => response.text())
        .then((result) => {
          var strval = result;
          if (!strval) strval = "[]";
          var newfile = JSON.parse(strval);
          store.dispatch("setMasterData", newfile);
          store.dispatch("setOverlay", false);
          callback(null);
        })
        .catch((error) => {
          store.dispatch("setMasterData", []);
          store.dispatch("setOverlay", false);
          callback(error);
        });
    })
    .catch((error) => {
      store.dispatch("setMasterData", []);
      store.dispatch("setOverlay", false);
      callback(error);
    });
};

export const saveFile = async (id, pos, content, callback) => {
  const saveData = JSON.parse(content);
  saveData["pos"] = +pos;
  return new Promise((resolve, reject) => {
    updateFile("catalogue" + pos + ".json", saveData)
      .then((response) => {
        return response.json();
      })
      .then(() => {
        callback(null);
        resolve();
      })
      .catch((error) => {
        callback(error);
        reject(error);
      });
  });

  /*var current_data=JSON.parse(content);
  if(current_data.catalogue.length>0)
  {
    upload_menu(content,store.state.current_store_id); 
  }
  if(current_data.catalogue.length==0 && current_data.nationalNumber!=null) 
  {
    await creating_Establishment(current_data.shopname,store.state.user.data.email).then(function(response){
    store.state.current_store_id=response.data.establishmentId;
    console.log(store.state);
    //   store.dispatch("setOverlay", false);
     });
    }*/
};
export const deleteFile = (id, pos, callback) => {
  const content = {};
  return new Promise((resolve, reject) => {
    updateFile("catalogue" + pos + ".json", content)
      .then((response) => {
        return response.json();
      })
      .then(() => {
        callback(null);
        resolve();
      })
      .catch((error) => {
        console.log("Error", error);
        callback(error);
        reject();
      });
  });
};

export const loadFile = (id, pos, state, callback) => {
  downloadUrl("catalogue" + pos + ".json")
    .then((response) => {
      return response.json();
    })
    .then((data) => {
      fetch(data.message, {
        method: "GET",
        redirect: "follow",
      })
        .then((response) => response.text())
        .then((result) => {
          var strval = result;
          if (!strval) strval = "[]";
          var newfile = JSON.parse(strval);
          state.currentForm.id = id;
          // setCurrentFormData(newfile, state);
          store.dispatch("setCurrentFormData", newfile);
          callback(null);
        })
        .catch((error) => {
          callback(error);
        });
    })
    .catch((error) => {
      callback(error);
    });
};

// export const fetchFromFref = (appid, fref, state, callback) => {
//   fref
//     .getDownloadURL()
//     .then(function (url) {
//       //console.log(url);
//       var requestOptions = {
//         method: "GET",
//         redirect: "follow",
//       };

//       fetch(url, requestOptions)
//         .then((response) => response.text())
//         .then((result) => {
//           //console.log(result);
//           var strval = result;
//           if (!strval) strval = "[]";
//           var newfile = JSON.parse(strval);
//           state.currentForm.id = appid;
//           // setCurrentFormData(newfile, state);
//           store.dispatch("setCurrentFormData", newfile);
//           callback(null);
//         });
//     })
//     .catch(function (error) {
//       callback(error);
//     });
// };
export const setCurrentFormData = (newfile, state) => {
  state.currentForm.shopname = newfile.shopname;
  state.currentForm.shopdesc = newfile.shopdesc;
  state.currentForm.type = newfile.type;
  state.currentForm.phone = newfile.phone;

  while (state.currentForm.catalogue.length > 0)
    state.currentForm.catalogue.pop();

  if (!newfile.catalogue) newfile.catalogue = [];

  for (var i = 0; i < newfile.catalogue.length; i++)
    state.currentForm.catalogue.push(newfile.catalogue[i]);

  var maxpos = 0;

  for (var j = 0; j < newfile.catalogue.length; j++)
    if (newfile.catalogue[j].pos >= maxpos)
      maxpos = newfile.catalogue[j].pos + 1;

  state.currentForm.maxlength = maxpos;
};
export const saveNumber = (id, name, phoneObject, callback) => {
  updateFile("locale.json", phoneObject)
    .then((response) => {
      return response.json();
    })
    .then(() => {
      callback(null);
    })
    .catch((error) => {
      console.log("Error", error);
      callback(error);
    });
};

export const saveLocale = (id, lang, callback) => {
  var content = { locale: lang };
  updateFile("locale.json", content)
    .then((response) => {
      return response.json();
    })
    .then(() => {
      callback(null);
    })
    .catch((error) => {
      callback(error);
    });
};
export const loadLocale = () => {
  downloadUrl("locale.json")
    .then((response) => {
      return response.json();
    })
    .then((data) => {
      fetch(data.message, {
        method: "GET",
        redirect: "follow",
      })
        .then((response) => response.text())
        .then((result) => {
          result = JSON.parse(result);
          store.dispatch("setLocale", result.locale);
          store.state.locale = result.locale;
          i18n.locale = result.locale;
        })
        .catch((error) => {
          store.dispatch("setLocale", "en");
          store.state.locale = "en";
          i18n.locale = "en";
        });
    })
    .catch((error) => {
      store.dispatch("setLocale", "en");
      store.state.locale = "en";
      i18n.locale = "en";
    });
};

export const saveImage = (id, name, image, callback) => {
  var storageRef = firebase.storage().ref();
  var fname = "/files/" + id + "/img" + name;
  var fref = storageRef.child(fname);
  var content = dataURLtoFile(image, name);

  try {
    fref
      .put(content)
      .then(function() {
        fref.getDownloadURL().then(function(newurl) {
          callback(null, newurl);
        });
      })
      .catch(function(error) {
        callback(error, null);
      });
  } catch (error) {
    callback(error, null);
  }
};
export const dataURLtoFile = (dataurl, filename) => {
  var arr = dataurl.split(","),
    mime = arr[0].match(/:(.*?);/)[1],
    bstr = atob(arr[1]),
    n = bstr.length,
    u8arr = new Uint8Array(n);
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }
  return new File([u8arr], filename, { type: mime });
};

export const saveMasterData = (callback, state) => {
  updateMasterData(state);
  updateFile("master.json", state.forms)
    .then((response) => {
      return response.json();
    })
    .then(() => {
      callback(null);
    })
    .catch((error) => {
      callback(error);
    });
};

export const deleteMasterData = (callback, state) => {
  return new Promise((resolve, reject) => {
    updateFile("master.json", state.forms)
      .then((response) => {
        return response.json();
      })
      .then(() => {
        resolve();
        callback(null);
      })
      .catch((error) => {
        console.log("Error", error);
        reject(error);
        callback(error);
      });
  });
};

export const updateMasterData = (state) => {
  if (!state.currentForm) return;
  const masterData = [...state.forms];
  const currentPossition = state.currentFormPos;
  let findCurrentForm = masterData.find((ele) => {
    return ele.link.split("/")[3] == currentPossition;
  });

  if (findCurrentForm) {
    const findCurrentFormIndex = masterData.findIndex((ele) => {
      return ele.link == findCurrentForm.link;
    });
    findCurrentForm.type = state.currentForm.type;
    findCurrentForm.shopname = state.currentForm.shopname;
    findCurrentForm.shopdesc = state.currentForm.shopdesc;
    masterData[findCurrentFormIndex] = findCurrentForm;
  } else {
    state.forms.push({
      shopname: state.currentForm.shopname,
      shopdesc: state.currentForm.shopdesc,
      type: state.currentForm.type,
      link: "/admin/editform/" + state.currentFormPos,
    });
  }
};
// Auth stuff
export const auth = firebase.auth();

// export const ui =  new firebaseui.auth.AuthUI(auth);

export const ui = async () => {
  var uiConfig = {
    signInSuccessUrl: "/admin",
    signInFlow: "popup",
    signInOptions: [
      firebase.auth.GoogleAuthProvider.PROVIDER_ID,
      {
        provider: firebase.auth.EmailAuthProvider.PROVIDER_ID,
        signInMethod: firebase.auth.EmailAuthProvider.EMAIL_LINK_SIGN_IN_METHOD,
        forceSameDevice: false,
      },
      {
        provider: firebase.auth.PhoneAuthProvider.PROVIDER_ID,
        defaultCountry: store.state.countryCode,
        recaptchaParameters: {
          type: "image", // 'audio'
          size: "normal", // 'invisible' or 'compact'
          badge: "bottomright", //' bottomleft' or 'inline' applies to invisible.
        },
      },
    ],
    // Terms and conditions url
    tosUrl: process.env.VUE_APP_TERMS_AND_CONDITIONS,
    // Privacy policy url/callback.
    privacyPolicyUrl: process.env.VUE_APP_PRIVACY_POLICY,
  };
  await firebase
    .auth()
    .setPersistence(
      process.env.NODE_ENV === "test"
        ? firebase.auth.Auth.Persistence.NONE
        : firebase.auth.Auth.Persistence.LOCAL
    );

  var script = document.createElement("script");
  if (i18n.locale == "en" || i18n.locale == "gu") {
    script.src =
      "https://www.google.com/recaptcha/api.js?onload=vueRecaptchaApiLoaded&render=explicit&hl=en";
    const firebaseui_en = require("firebaseui/dist/npm");
    let ui =
      firebaseui_en.auth.AuthUI.getInstance() ||
      new firebaseui_en.auth.AuthUI(auth);
    ui.start("#login-container-1", uiConfig);
    addStyle();
  } else if (i18n.locale == "pt") {
    script.src =
      "https://www.google.com/recaptcha/api.js?onload=vueRecaptchaApiLoaded&render=explicit&hl=pt-BR";
    const firebaseui_pt = require("firebaseui/dist/npm__pt_br");
    let ui =
      firebaseui_pt.auth.AuthUI.getInstance() ||
      new firebaseui_pt.auth.AuthUI(auth);
    ui.start("#login-container-1", uiConfig);
    addStyle();
  } else if (i18n.locale == "es") {
    script.src =
      "https://www.google.com/recaptcha/api.js?onload=vueRecaptchaApiLoaded&render=explicit&hl=es-419";
    const firebaseui_es = require("firebaseui/dist/npm__es_419");
    let ui =
      firebaseui_es.auth.AuthUI.getInstance() ||
      new firebaseui_es.auth.AuthUI(auth);
    ui.start("#login-container-1", uiConfig);
    addStyle();
  } else if (i18n.locale == "ru") {
    script.src =
      "https://www.google.com/recaptcha/api.js?onload=vueRecaptchaApiLoaded&render=explicit&hl=ru";
    const firebaseui_ru = require("firebaseui/dist/npm__ru");
    let ui =
      firebaseui_ru.auth.AuthUI.getInstance() ||
      new firebaseui_ru.auth.AuthUI(auth);
    ui.start("#login-container-1", uiConfig);
    addStyle();
  } else if (i18n.locale == "hi") {
    script.src =
      "https://www.google.com/recaptcha/api.js?onload=vueRecaptchaApiLoaded&render=explicit&hl=hi";
    const firebaseui_hi = require("firebaseui/dist/npm__hi");
    let ui =
      firebaseui_hi.auth.AuthUI.getInstance() ||
      new firebaseui_hi.auth.AuthUI(auth);
    ui.start("#login-container-1", uiConfig);
    addStyle();
  }
  document.getElementsByTagName("head")[0].appendChild(script);
};

function addStyle() {
  var styles = ".firebaseui-list-box-dialog { visibility: visible }";
  var css = document.createElement("style");
  if (css.styleSheet) css.styleSheet.cssText = styles;
  else css.appendChild(document.createTextNode(styles));
  document.getElementsByTagName("head")[0].appendChild(css);
}

export const signOut = async () => {
  // console.log("signOut");
  await auth.signOut();
};

export const setLocale = () => {
  if (store.state.locale != i18n.locale) {
    i18n.locale = store.state.locale;
  }
};
function userAnalytics(eventName, data) {
  analytics.logEvent(eventName, {
    displayName: data.displayName,
    email: data.email,
    phoneNumber: data.phoneNumber,
    provider: data.providerData[0].providerId,
    user: JSON.stringify(data.providerData[0]),
  });
}
// export const formNameAnalytics = (eventName, data) =>{
//       analytics.logEvent(eventName, {
//         formType: data.type
//       })
// };
export const saveUser = (id, user, callback) => {
  var content = {
    user: user,
  };
  updateFile("user.json", content)
    .then((response) => {
      return response.json();
    })
    .then(() => {
      callback(null);
    })
    .catch((error) => {
      callback(error);
    });
};

export const generateJWTToken = async (id) => {
  var config = {
    method: "get",
    url: `${process.env.VUE_APP_API_ENDPOINT}fsdata/v1/create-jwt-token/${id}`,
    headers: {
      "Content-Type": "application/json",
    },
  };
  await axios(config)
    .then(async function(response) {
      await store.dispatch("setJWTToken", response.data.token);
      if (!store.state.user.data.email) fetchingLogoutData(id);
    })
    .catch(function(error) {
      console.log(error);
    });
};
const userChecking = async (merchant_id, token) => {
  var config = {
    method: "get",
    url: `${process.env.VUE_APP_API_ENDPOINT}fsdata/v1/userChecking/${merchant_id}?token=${token}`,
    headers: {
      "Content-Type": "application/json",
    },
  };

  await axios(config)
    .then(function() {
      generateJWTToken(merchant_id);
    })
    .catch(function(error) {
      console.log(error);
    });
};

firebase.auth().onAuthStateChanged(
  function(user) {
    if (user) {
      Token(user.uid);
      saveLocale(user.uid, store.state.locale, function() {});
      store.state.currentForm.id = user.uid;
      if (user.metadata.lastSignInTime == user.metadata.creationTime) {
        userAnalytics("newUser", user);
        saveUser(user.uid, user, function(error, response) {
          if (error) {
            // alert(i18n.t("alertText.userDetails"));
          } else console.log(response);
        });
      } else {
        if (!store.state.profile.isSigned) {
          userAnalytics("returnUser", user);
          saveUser(user.uid, user, function(error, response) {
            if (error) {
              // alert(i18n.t("alertText.userDetails"));
            } else console.log(response);
          });
        }
      }
    }
    store.dispatch("setDialog", false);
    if (user) {
      store.dispatch("fetchUser", user);
      var displayName = user.displayName;
      var email = user.email;
      var emailVerified = user.emailVerified;
      var photoURL = user.photoURL;
      var uid = user.uid;
      var phoneNumber = user.phoneNumber;
      var providerData = user.providerData;
      user.getIdToken().then(function(accessToken) {
        var loginuser = {
          displayName: displayName,
          email: email,
          emailVerified: emailVerified,
          phoneNumber: phoneNumber,
          photoURL: photoURL,
          uid: uid,
          accessToken: accessToken,
          providerData: providerData,
        };

        store.dispatch("setOverlay", true);

        var routename = router.currentRoute.name;
        if (routename === "viewform") {
          store.dispatch("setOverlay", false);
          //Nothing
        } else {
          if (user) {
            login(loginuser);
            store.dispatch("setOverlay", false);
          } else {
            store.dispatch("setOverlay", false);
          }
        }
      });
    } else {
      store.dispatch("setOverlay", true);
      var routename = router.currentRoute.name;
      if (routename === "viewform") {
        //Nothing
      } else {
        if (user) {
          login(user);
          loadMaster(user.uid, function() {
            store.dispatch("setOverlay", false);
          });
        } else {
          store.dispatch("setOverlay", false);
        }
      }

      return null;
    }
  },
  function() {}
);
window.onscroll = () => {
  let scrollValue = window.scrollY;
  if (scrollValue > 60) {
    if (document.querySelector(".navbar")) {
      document.querySelector(".navbar").classList.add("affix");
    }
  } else {
    if (document.querySelector(".navbar")) {
      document.querySelector(".navbar").classList.remove("affix");
    }
  }
};
// onMessageListener
export const onMessageListener = () =>
  new Promise((resolve) => {
    if (firebase.messaging.isSupported()) {
      messaging.onMessage((payload) => {
        resolve(payload);
      });
    }
  });

export { messaging };
